const notificationMessage = {
  padding: '1.5rem 0',
};

export { notificationMessage };
